
import { RAW_MATERIAL_SUPPLIER } from 'actionTypes';
import thunkFactory from 'source/utils/redux/baseEntitiesFactory/thunk';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';

// ACTIONS
const rawActions = actionsFactory(RAW_MATERIAL_SUPPLIER);
const actions = { ...rawActions, ...thunkFactory(RAW_MATERIAL_SUPPLIER, '/raw_material_suppliers/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

const options = {
  flattenFields: {
    raw_material_id: ['name'],
    supplier_id: ['name', 'id']
  }
};

export default reducerFactory(RAW_MATERIAL_SUPPLIER, initialState, options);

// SAGAS
const sagas = sagasFactory(RAW_MATERIAL_SUPPLIER, '/raw_material_suppliers/', { scopedByAccount: true });
export { sagas };
